<template>
    <div class="app"  v-if="bShowPropress">
        <div class="propress-wrap">
            <div class="propress-box">
                <h4>长图生成中...</h4>
                <div class="propress">
                    <div :style="{width:nRate+'%'}"><span v-show="nRate>10">{{nRate}}%</span></div>
                </div>
                <div class="tips">长按可保存长图</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props:{
        bShowPropress:{
            type:Boolean,
            default:false
        },
        nRate:{
            type:Number,
            default:0
        }
    }
}
</script>

<style lang="scss" scoped>
    .propress-wrap{
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: #ffffff;
        z-index: 999;
        display: flex;
        align-items: center;
        .propress-box{
            padding: 0 104px;
            width: 100%;
            h4{
                color: #282828;
                font-size: 32px;
                margin-bottom: 54px;
                text-align: center;
            }

            .propress{
                border: solid 4px #263266;
                height: 68px;
	            border-radius: 34px;
                overflow: hidden;
                div{
                    height: 60px;
                    border-radius: 30px;
                    background-color: #263266;
                    width: 0;
                    color: #ffffff;
                    font-size: 30px;
                    padding-right: 20px;
                    line-height: 60px;
                    text-align: right;
                    transition: all .5s;
                }
            }
            .tips{
                width: 234px;
                height: 73px;
                background-color: rgba(0,0,0,.4);
                border-radius: 10px;
                color: #ffffff;
                line-height: 73px;
                font-size: 30px;
                color: #ffffff;
                text-align: center;
                margin: 50px auto 0 ;
            }
        }
    }
</style>